module.exports = __webpack_public_path__ + "img/TheDeck_PlayingCards_square.bd22f3f9.jpg";